<template>
  <div class="grid card px-3 py-1 shadow-2" >
    <!-- Header -->
    <div class="col-12 flex justify-content-between align-items-center border-bottom-1 border-black-alpha-30 p-0 mb-2">
      <h2 class="text-2xl font-light">Nuevo Afectado</h2>
      <div class="button_Section_process guardar" v-if="arrId">
        <Button
          label="Guardar"
          icon="pi pi-back"
          @click="handleSaveDenunciante()"
          test-id="buttonSaveDenuciante"
          :disabled="!isTouched || hasErrors"
        />
      </div>
    </div>
    <!-- Lista de personas -->
    <div v-if="!minimal" class="col-12 md:col-4 lg:col-3 lateral" >
      <div class="flex justify-content-between align-items-center w-full border-round-md shadow-2 border-none px-3 mb-2" style="border: 1px solid red;">
        <h3 class="font-light text-black-alpha-50">Afectados</h3>
        <Button
          icon="pi pi-plus"
          class="p-button-success p-button-lg p-button-rounded p-button-outlined px-2 py-2 m-1"
          style="z-index: 3"
          @click="handleNewAfectado"
          test-id="addAfectado"
        />  
      </div>
      <Listbox
        v-model="dataArrId"
        :options="denuncianteTodosSelect"
        dataKey="arrId"
        optionValue="arrId"
        optionLabel="name"
        ref="listBox"
        test-id="listDenunciantes"
        class="border-round-md shadow-2 border-none"
        v-if="denuncianteTodosSelect[0].type !== 'empty'"
      >
        <template #option="slotProps">
          <div class="flex justify-content-between align-items-center" v-if="slotProps.option.type !== 'empty'">
            <div class="flex flex-column text-base w-full">
              <div class="mb-2">
                <span class="uppercase font-semibold" v-if="slotProps.option.apellido">{{ slotProps.option.apellido }}, </span>
                <span>{{ slotProps.option.name }}.</span>
              </div>
              <span class="block mb-2" v-if="slotProps.option.type !== 'empty'" >DNI: {{ slotProps.option.documento }}</span>
              <Tag
                :severity="colorTag(slotProps.option.condicion.nombre)"
                :class="colorTag(slotProps.option.condicion.nombre)"
                class="w-max"
                :value="slotProps.option.condicion?.nombre"
                rounded
                v-if="slotProps.option.type !== 'empty'"
              />
            </div>
            <Button
              v-if="slotProps.option.type !== 'empty'"
              icon="pi pi-trash"
              class="p-button-danger p-button-lg p-button-rounded p-button-outlined px-2 py-2 m-1"
              style="z-index: 3"
              @click.stop="confirmDelete(slotProps.option.arrId)"
            />  
          </div>
        </template>
      </Listbox>
      <div class="button_Section_process volver">
        <Button
          label="Volver"
          icon="pi pi-back"
          @click="handleBackToMainForm()"
          test-id="buttonVolver"
        />
      </div>
    </div>
    <!-- Formulario -->
    <div :class="{ 'col': !minimal }">
      <div
        class="field-checkbox ml-2"
        :class="{ notVisible: checkOrdenPublico() }"
        v-if="
          arrId &&
          viewData[viewData.actuacion].checkboxPublicOrder
        "
      >
        <Checkbox id="binary" v-model="ordenPublico" :binary="true" />
        <label for="binary">Orden público</label>
      </div>
      <div
        :class="{hideForm: formData.type === null || ordenPublico}"
        class="card shadow-2"
      >
        <FormPersona
          ref="denunciante"
          :acusado="false"
          @update:persona="updatePersona"
          @validationStatus="handleValidationStatus"
          :arrId="arrId"
          :getPersonByArrId="getDenuncianteByArrId"
          :ordenPublico = "ordenPublico"
          :formType = "formType"
          typeOfPerson="denunciante"
          :hidden="viewData[viewData.actuacion].formPersona.hidden"
          :Involucrados="denuncianteTodosSelect"
        />
      </div>
    </div>
    <ModalTemplate 
      title="Información"
      type="informativo"
      :message="modalRefInformMessage"
      :showIcon="true"
      @confirm="closeModal()"
      severity="danger"
      ref="ModalRefInform"
      :closable="false"
    />
    <ModalTemplate
      title="Confirmación de Eliminación"
      type="confirmativo"
      message="¿Está seguro de que desea eliminar este elemento?"
      :showIcon="true"
      severity="danger"
      @confirm="deleteConfirmed"
      @cancel="cancelDelete"
      ref="ModalRefDelete"
    />
    <ModalSucces 
      title="¿Estás seguro de que quieres volver?"
      type="confirmativo"
      :message="modalRefSaveMessage"
      :showIcon="true"
      @confirm="backToTheMainForm"
      @cancel="cancelBack"
      :closable="false"
      severity="success"
      ref="ModalRefSave"
    />
    <ModalSucces 
      title="¡Los datos se guardaron con éxito!"
      type="success"
      :message="modalRefSaveSuccess"
      :showIcon="true"
      @confirm="backToTheMainForm"
      @cancel="cancelBack"
      :closable="false"
      severity="success"
      ref="ModalRefSaveSuccess"
    />
  </div> 
</template>

<script>
import Listbox from "primevue/listbox";
import FormPersona from "../forms/FormPersona.vue";
import ModalTemplate from '../../components/ModalTemplate.vue'

import { mapGetters, mapState } from "vuex";
import ModalSucces from "../ModalSucces.vue";
import Card from "primevue/card/Card";
export default {
  name: "FormDenunciantes",
  components: {
    FormPersona,
    Listbox,
    ModalTemplate,
    ModalSucces,
    Card
  },
  props: {
    minimal: {
      type: String, 
    },
    predefined: {
      type: Object, 
    },
    aid: {
      type: String, 
    },
    formType: String,
    actuacionType: String 
  },
  data() {
    return {
      arrId: this.aid || null,
      firstTime: true,
      saveOrBackButtonActive: false,
      formDataCopy: {},
      denuncianteData: null, 
      modalRefInformMessage: '',
      modalRefSaveMessage: '',
      modalRefSaveSuccess: '',
      validationErrors: {},
      isTouched: false,
      hasErrors: false,
    };
  },
  mounted() {
    if (
      typeof this.getDenuncianteByArrId(this.$router.currentRoute.query.id) !=
      "undefined"
    ) {
      this.arrId = this.$router.currentRoute.query.id;
    }   
  },
  created() { 
    
    if(this.$route.query.id == 'new')
    {
      this.arrId = this.denuncianteTodosSelect[(this.denuncianteTodosSelect.length)-1].arrId
    }    
  },
  computed: {
    ...mapGetters("sumario/denunciante", [
      "getDenuncianteByArrId",
      "getEmptyDocDenunciante",
      "getNewDenuncianteArrId",
      "denuncianteTodosSelect",
    ]),
    ...mapState({
      denunciante: (state) => state.sumario.denunciante,
      viewData: (state) => state.sumarioViews,
    }),
    formData: {
      get() {
        if (this.predefined && !this.arrId) {
          if (this.predefined.new) {
            return {
              doc: {},
              type: "empty",
              ordenPublico: this.predefined.default.ordenPublico,
            };
          }
        }
        if (this.arrId) {
          this.denuncianteData = {...this.getDenuncianteByArrId(this.arrId).doc}
          return this.getDenuncianteByArrId(this.arrId);
        }
        return { doc: {}, type: null, ordenPublico: false };
      },
    },
    ordenPublico: {
      get() {
        return this.formData.ordenPublico;
      },
      set(value) {
        this.isTouched = true
        this.$_TemplateParentForm_updateValue("ordenPublico", value);
      },
    },

    dataArrId: {
      get() {
        return this.arrId;
      },
      set(value) {
        this.arrId = value;
      },
    },
  },
  watch: {
    arrId: function (newValue) {
      if (
        newValue != null &&
        this.$router.currentRoute.query.id != newValue 
      ){
        this.$router.push({ path: `/actuaciones/new/${this.actuacionType}/initial/denunciante?id=${newValue}` });
      }
    },
    formData: function (newValue) {
      if (typeof newValue != "object") return;
      if(this.firstTime){
        setTimeout(() => { 
          this.updateFormPersona(newValue)
          this.firstTime = false
        }, 1)
      } else {
        this.updateFormPersona(newValue)
      }
    },
    validationErrors: {
      handler(newErrors) {
        this.hasErrors = Object.values(newErrors).some(
          (error) => error !== null && error !== ""
        );
      }
    }
  },

  methods: {
    handleNewAfectado(){
      const id = this.denuncianteTodosSelect[(this.denuncianteTodosSelect.length)-1].arrId
      this.$router.push({
        path: `/actuaciones/new/${this.actuacionType}/initial/denunciante?id=${id}`,
      });
    },
    async handleSaveDenunciante(){
      if (!this.formData.arrId) {
        this.formData.arrId = await this.getNewDenuncianteArrId;
      }
      this.validacion('/actuaciones/new/' + this.actuacionType + '/initial')
      await this.$store.dispatch("sumario/denunciante/setDenunciante", {
          ...this.formData,
          doc:{ ...this.denuncianteData},
        });
      await this.$store.dispatch("sumario/denunciante/setEmptyTitle", this.viewData[this.viewData.actuacion].formPersona.whistleblower.emptyTitle);
      this.$_TemplateParentForm_setArrId();
      this.modalRefSaveSuccess = "La información se ha guardado correctamente. Si desea realizar una nueva carga, haga click en 'Seguir cargando'. En caso de querer regresar a la página anterior, haga click en 'Volver'.";
      this.$refs.ModalRefSaveSuccess.open()
    },
    handleValidationStatus(errors) {
      this.validationErrors = { ...errors };

    },
    updatePersona(nuevaData) {
      if(nuevaData.apellido){
        this.isTouched = true
      }
      this.denuncianteData = nuevaData;
    },
    checkOrdenPublico() {
      for (let item of this.denunciante.list) {
        if (item.ordenPublico == true) {
          return true;
        }
      }
      return false;
    },
    activeComponent() {
      this.$refs.denunciante.setData(this.formData.doc);
    },

    $_TemplateParentFor_setValue(data) {
      if (!this.predefined) return;
      if (!this.predefined.valueFactory) return;
      let text = this.predefined.valueFactory;

      let charters = false;
      
      if (charters) {
        const regexCharters = /{textDescription}/gi;
        text = text.replace(regexCharters, charters);
      }

      if (data.doc.sexo) {
        text = text.replace(/{sexo}/gi, data.doc.sexo.nombre);
      }

      if (data.doc.nombre) {
        text = text.replace(/{nombre}/gi, data.doc.nombre);
      }

      if (data.doc.apellido) {
        text = text.replace(/{apellido}/gi, data.doc.apellido);
      }
      if (data.doc.documento) {
        text = text.replace(/{dni}/gi, data.doc.documento);
      }
      this.$emit("setValue", text);
    },
    async $_TemplateParentForm_updateValue(field, value) {
      let formDataType = 'formData';
      if (!this.formData.arrId) {
        this.formData.arrId = await this.getNewDenuncianteArrId;
      }
      if(field === 'ordenPublico' && value === true){
        formDataType = 'formDataCopy';
        this.formDataCopy = {...this.formData};
        const propsToKeep  = ['condicion', 'arrId', 'instruccion', 'nacionalidad', 'tipoDocumento'];
        this.formDataCopy.doc = propsToKeep.reduce((obj, key) => (key in this.formData.doc && (obj[key] = this.formData.doc[key]), obj), {});
      }
      await this.$store.dispatch("sumario/denunciante/setDenunciante", {
        ...this[formDataType],
        [field]: value,
      });

      this.$_TemplateParentForm_setArrId();
    },
    async $_TemplateParentForm_handleUpdateDocValue(field, value) {
      if (!this.formData.arrId) {
        this.formData.arrId = await this.getNewDenuncianteArrId;
      }
      await this.$store.dispatch("sumario/denunciante/setEmptyTitle", this.viewData[this.viewData.actuacion].formPersona.whistleblower.emptyTitle);
      this.$_TemplateParentForm_setArrId();
    },
    $_TemplateParentForm_setArrId() {
      if (!this.arrId) {
        this.arrId = this.formData.arrId;
        if (this.predefined) {
          this.$emit("setArrId", this.arrId);
        }
      }
    },
    $_TemplateParentForm_delete(arrId) {
      this.arrId = null;
      this.$store.dispatch(
        "sumario/denunciante/deleteDenuncianteByArrId",
        arrId
      );
    },
    updateFormPersona(newValue){
      this.$refs.denunciante.setData(newValue.doc);
      if (newValue.doc.personaJuridica) {
        this.$refs.denunciante.personaJuridica = newValue.doc.personaJuridica;
      } else {
        this.$refs.denunciante.personaJuridica = false;
      }
      this.$_TemplateParentFor_setValue(newValue);  
    },

    validacion(route){
      this.saveOrBackButtonActive = true;
      if(!this.validateEmail()) return;
      let errores = this.$refs.denunciante.emitErrores()
      if(errores == true){
        alert("Verifica los campos")
      }
    },

    validateEmail(){
      // if(this.validateEmailWarning()) return changeRoute;
      // return this.validateEmailError();
    },
    
    closeModal(){
      this.$refs.ModalRefInform.close();
      this.$refs.denunciante.$el.querySelector("#emailInput").select();
    },
    closeModalWarning(){
      this.$refs.ModalRefInformWarning.close();
      this.saveOrBackButtonActive = false;
    },
    handleBackToMainForm(){
      this.modalRefSaveMessage = 'Antes de volver, asegúrese de haber guardado los datos ingresados. Si ya los ha guardado, puede continuar. Si no ha guardado los datos, hágalo ahora para evitar la pérdida de información.'
      this.$refs.ModalRefSave.open()
    },
    backToTheMainForm(){
      this.saveOrBackButtonActive = true;
      this.$router.push( '/actuaciones/new/' + this.actuacionType + '/initial/');
    },
    cancelBack(){
      this.$refs.ModalRefSave.close();
      this.$refs.ModalRefSaveSuccess.close()
    },
    validateEmailError(){
      let validation = this.$rest.validateEmail(this.$refs.denunciante?.email);
      if(this.$refs.denunciante.condicion.nombre === 'Denunciante'){
        this.modalRefInformMessage = 'Se requiere un email con formato válido.';
      } else {
        this.modalRefInformMessage = 'Se requiere un email válido o dejar el campo vacío si no tienes uno disponible.';
      }
      if(validation !== true){
        this.$refs.ModalRefInform.open();
      } 
      return validation;
    },
    colorTag(value) {
      switch (value) {
        case "Denunciante y Damnificado":
          return "success";
        case "Denunciante":
          return "primary";
        case "Damnificado":
          return "warning";
        case "Víctima":
          return "info";
        case "Fallecido":
          return "secondary";
        case "Protagonista":
          return "primary";
        case "Acompañante":
          return "warning";
        case "Peatón":
          return "help";
        default:
          return "";
      }
    },
    confirmDelete(id) {
      this.idToDelete = id; 
      this.$refs.ModalRefDelete.open();
    },
    deleteConfirmed() {
      if (this.idToDelete) {
        this.$_TemplateParentForm_delete(this.idToDelete); 
        this.idToDelete = null; 
        this.$refs.ModalRefDelete.close(); 
      }
    },
    cancelDelete() {
      this.idToDelete = null; 
      this.$refs.ModalRefDelete.close();
    },
  },
};
</script>
<style scoped>
.card {
  background: #ffffff;
  padding: 2rem;
  -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-bottom: 1rem;
}
.hideForm {
  display: none;
}
.button_Section_process {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.button_Section_process:not(.volver) {
  margin-right: 25px;
}

.guardar {
  margin-top: -05px;
}

.volver {
  margin-top: 10px;
}

.p-listbox .p-listbox-item.p-highlight {
  background-color:red !important; /* Gris claro */
  color: #333 !important; /* Texto oscuro */
}

@media screnn and (max-width: 768px) {
}
.pad {
  padding: 1rem 0.7rem;
}
.lateral > button {
  margin-top: 20px;
}
.pad > div {
  margin-right: 30px;
}
.notVisible {
  display: none;
}

</style>